

export const upsellCheck = (to, from, next) => {
  if (from.name !== 'landing' && from.name) return next()
  const subscriptionInfo = JSON.parse(localStorage.getItem('usersSubscriptionInfo'))
  if (subscriptionInfo) next()
  else next({name: 'landing'})
}
